import { render, staticRenderFns } from "./Publication.vue?vue&type=template&id=cb807430&scoped=true&"
import script from "./Publication.vue?vue&type=script&lang=js&"
export * from "./Publication.vue?vue&type=script&lang=js&"
import style0 from "./Publication.vue?vue&type=style&index=0&id=cb807430&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb807430",
  null
  
)

export default component.exports